<script>
import Form from '@classes/Form'
import { VueTelInputVuetify } from 'vue-tel-input-vuetify'
import { patientService } from '@services/PatientService'
import { caringCircleService } from '@/src/services/safehaven/AddCaringCircleService'
import CaringProfilePicture from '@components/safehaven/care-club/caring-circle-profile.vue'
import moment from 'moment'
import CustomSnackbar from '@components/custom-snackbar.vue'

export default {
  components: {
    VueTelInputVuetify,
    CustomSnackbar,
    CaringProfilePicture,
  },
  page: {
    title: 'Caring-person-info',
    meta: [{ name: 'description', content: 'The Caring-person-info page.' }],
  },

  data() {
    return {
      userData: '',
      valid: false,
      imperialUnits: '',
      iconCalender: 'mdi-calendar-blank',
      iconMap: 'mdi-map-marker',
      date: '',
      currentDateWithFormat: new Date()
        .toJSON()
        .slice(0, 10)
        .replace(/-/g, '-'),

      selectDate: null,
      form: new Form({
        profilePictureUrl: null,
        userFname: '',
        userLname: '',
        userDob: '',
        userRelation: '',
        userSex: '',
        userGenderIdentity: '',
        userWeight: null,
        userWeightLbs: null,
        userHeightFt: null,
        userHeightIn: null,
        userHeightMeters: null,
        userEmail: '',
        userRace: '',
        userOccupation: '',
        userPhone: '',
        emergencyFname: '',
        emergencyLname: '',
        emergencyAddress: '',
        emergencyCity: '',
        emergencyState: '',
        emergencyZip: '',
        emergencyPhn: '',
        primaryFname: '',
        primaryLname: '',
        primarySpeciality: '',
        primaryHospital: '',
        primaryPhn: '',
        notes: '',
      }),
      meters: '',
      enableButton: false,
      changeData: false,
      userMessage: '',
      relationships: [],
      sex: [],
      genderIdentity: null,
      ethnicity: null,
      states: null,
      invalidMessage: '',

      notGreekRule: [
        (v) =>
          !v || !v.length > 0 || /^[a-zA-Z0-9., ]+$/g.test(v) || 'Invalid data',
      ],

      onlyNumberRegex: [
        (v) =>
          !v ||
          !v.length > 0 ||
          /([+]?\d{1,2}[.-\s]?)?(\d{3}[.-]?){2}\d{4}/g.test(v) ||
          'Invalid data',
      ],

      fnameRule: [
        (v) => !!v || 'First name is required',
        (v) => /^[a-zA-Z, ]+$/g.test(v) || 'Invalid name format',
      ],

      lnameRule: [
        (v) => !!v || 'Last name is required',
        (v) => /^[a-zA-Z, ]+$/g.test(v) || 'Invalid name format',
      ],

      requiredRule: [(v) => !!v || 'Field is required'],

      dobRule: [(v) => !!v || 'Date of birth is required'],

      zipRule: [
        (v) =>
          !v ||
          !v.length > 0 ||
          /^\d{5}(-\d{4})?$/.test(v) ||
          'Invalid Zip Code,It should be in the format of 12345 or 12345-1234.',
      ],

      emailRules: [
        (v) =>
          !v || !v.length > 0 || /.+@.+/.test(v) || 'Invalid Email Address',
      ],
      snackbar: false,
      snackbarMessage: '',
    }
  },
  computed: {
    computedDateFormatted() {
      if (this.currentDateWithFormat === this.date) {
        return this.date ? moment(this.date).format('MM/DD/yyyy') : ''
      } else {
        return this.date ? moment(this.date).format('MM/DD/yyyy') : ''
      }
    },
    disableButton() {
      if (!this.valid) {
        return true
      }
      if (this.changeData) {
        return false
      } else if (
        this.form.userGenderIdentity === '' ||
        this.form.userWeight === '' ||
        this.form.userHeightFt === '' ||
        this.form.userHeightIn === '' ||
        this.form.userRace === '' ||
        this.form.userOccupation === '' ||
        this.form.notes === '' ||
        !this.changeData
      ) {
        return true
      } else {
        return null
      }
    },
  },
  watch: {
    form: {
      deep: true,
      handler(newValue) {
        return this.onChangeInput
      },
    },
  },
  created() {
    const userLogedData = JSON.parse(localStorage.getItem('auth.currentUser'))
    this.imperialUnits = userLogedData.user.imperial_units
    this.userData = this.$route.params.myparam
    if (this.userData) {
      this.updateCaringUserInfo()
    }
  },

  async mounted() {
    // Get PatientOptions
    const patientOptions = (await patientService.options()).data

    if (patientOptions) {
      this.sex = patientOptions.sex
      this.genderIdentity = patientOptions.gender
      this.ethnicity = patientOptions.race
      this.relationships = patientOptions.relationship
      this.states = patientOptions.states
    }
    if (this.userData) {
      this.updateCaringUserInfo()
    }
  },

  methods: {
    onlyInches(e, val) {
      const char = String.fromCharCode(e.keyCode) // Get the character
      var charCode = e.which ? e.which : e.keyCode
      if (
        parseFloat(
          this.form.userHeightFt +
            '.' +
            (val + e.key < 10 ? parseInt('0') + (val + e.key) : val + e.key)
        ) > 7.1
      ) {
        return e.preventDefault()
      }
      if (charCode === 46) {
        return e.preventDefault()
      }
      if (!/^[A-Za-z]+$/.test(char)) {
        if (val) {
          if (parseInt(val + e.key) < 12) {
            return true
          } else e.preventDefault()
        } else {
          return true
        }
      }
      // Match with regex
      else e.preventDefault()
    },
    onlyLBS(e, value, maxLength) {
      var charCode = e.which ? e.which : e.keyCode
      if (parseFloat(value + e.key) > 650) {
        return e.preventDefault()
      }
      if (value.length === 4 && value.indexOf('.') === -1 && charCode !== 46) {
        return e.preventDefault()
      }
      if (
        charCode === 46 &&
        (value.length === 0 || value.length === maxLength)
      ) {
        return e.preventDefault()
      }
      if (
        value.indexOf('.') !== -1 &&
        value.indexOf('.') + 3 === value.length
      ) {
        return e.preventDefault()
      }
      if (charCode === 8 || charCode === 37) {
        return true
      } else if (charCode === 46 && value.indexOf('.') !== -1) {
        return e.preventDefault()
      } else if (
        charCode > 31 &&
        charCode !== 46 &&
        (charCode < 48 || charCode > 57)
      ) {
        return e.preventDefault()
      }
      return true
    },
    onlyKG(e, value, maxLength) {
      var charCode = e.which ? e.which : e.keyCode

      if (parseFloat(value + e.key) > 300) {
        return e.preventDefault()
      }
      if (value.length === 3 && value.indexOf('.') === -1 && charCode !== 46) {
        return e.preventDefault()
      }
      if (
        charCode === 46 &&
        (value.length === 0 || value.length === maxLength)
      ) {
        return e.preventDefault()
      }
      if (
        value.indexOf('.') !== -1 &&
        value.indexOf('.') + 3 === value.length
      ) {
        return e.preventDefault()
      }
      if (charCode === 8 || charCode === 37) {
        return true
      } else if (charCode === 46 && value.indexOf('.') !== -1) {
        return e.preventDefault()
      } else if (
        charCode > 31 &&
        charCode !== 46 &&
        (charCode < 48 || charCode > 57)
      ) {
        return e.preventDefault()
      }
      return true
    },
    onlyHeightMeter(e, value, maxLength) {
      var charCode = e.which ? e.which : e.keyCode
      if (parseFloat(value ? value + e.key : e.key) > 2.4) {
        return e.preventDefault()
      }
      if (value.length === 1 && value.indexOf('.') === -1 && charCode !== 46) {
        return e.preventDefault()
      }
      if (
        charCode === 46 &&
        (value.length === 0 || value.length === maxLength)
      ) {
        return e.preventDefault()
      }
      if (
        value.indexOf('.') !== -1 &&
        value.indexOf('.') + 3 === value.length
      ) {
        return e.preventDefault()
      }
      if (charCode === 8 || charCode === 37) {
        return true
      } else if (charCode === 46 && value.indexOf('.') !== -1) {
        return e.preventDefault()
      } else if (
        charCode > 31 &&
        charCode !== 46 &&
        (charCode < 48 || charCode > 57)
      ) {
        return e.preventDefault()
      }
      return true
    },
    onlyHeightFeet(e, value) {
      const char = String.fromCharCode(e.keyCode) // Get the character
      var charCode = e.which ? e.which : e.keyCode
      if (parseFloat(value ? value + e.key : e.key) > 7) {
        return e.preventDefault()
      }
      if (charCode === 46) {
        return e.preventDefault()
      }
      if (!/^[A-Za-z]+$/.test(char)) return true
      // Match with regex
      else e.preventDefault()
    },
    isOnlydecimal(e, value, maxLength) {
      var charCode = e.which ? e.which : e.keyCode
      if (
        charCode === 46 &&
        (value.length === 0 || value.length === maxLength)
      ) {
        return e.preventDefault()
      }
      if (
        value.indexOf('.') !== -1 &&
        value.indexOf('.') + 3 === value.length
      ) {
        return e.preventDefault()
      }
      if (charCode === 8 || charCode === 37) {
        return true
      } else if (charCode === 46 && value.indexOf('.') !== -1) {
        return e.preventDefault()
      } else if (
        charCode > 31 &&
        charCode !== 46 &&
        (charCode < 48 || charCode > 57)
      ) {
        return e.preventDefault()
      }
      return true
    },
    updateCaringUserInfo() {
      if (this.userData) {
        this.form.profilePictureUrl =
          this.userData.dependent_data.profile_picture
        this.form.userFname = this.userData.dependent_data.first_name
        this.form.userLname = this.userData.dependent_data.last_name
        this.form.userDob = this.userData.dependent_data.dob
        this.date = this.userData.dependent_data.dob
        this.form.userRelation = this.userData.dependent_data.relationship?.key
        this.form.userSex = this.userData.dependent_data.sex?.key
        this.form.userGenderIdentity = this.userData.dependent_data.gender?.key
        this.form.userWeight = this.userData.dependent_data.weight
        this.form.userHeightMeters = this.userData.dependent_data.height
        this.setInputsWeightHeight()
        this.form.userEmail = this.userData.dependent_data.email
        this.form.userPhone = this.userData.dependent_data.phone_number
        this.form.userRace = this.userData.dependent_data.race?.key
        this.form.userOccupation = this.userData.dependent_data.occupation
        this.form.emergencyFname =
          this.userData.emergency_contact_data.first_name
        this.form.emergencyLname =
          this.userData.emergency_contact_data.last_name
        this.form.emergencyAddress =
          this.userData.emergency_contact_data.address
        this.form.emergencyCity = this.userData.emergency_contact_data.city
        this.form.emergencyState =
          this.userData.emergency_contact_data.state?.key
        this.form.emergencyZip = this.userData.emergency_contact_data.zipcode
        this.form.emergencyPhn =
          this.userData.emergency_contact_data.phone_number
        this.form.primaryFname = this.userData.physician_data.first_name
        this.form.primaryLname = this.userData.physician_data.last_name
        this.form.primarySpeciality = this.userData.physician_data.speciality
        this.form.primaryHospital = this.userData.physician_data.hospital
        this.form.primaryPhn = this.userData.physician_data.phone_number
        this.form.notes = this.userData.dependent_data.notes
      } else {
        this.form.userFname = ''
        this.form.userLname = ''
        this.form.userDob = ''
        this.date = ''
        this.form.userRelation = ''
        this.form.userSex = ''
        this.form.userGenderIdentity = ''
        this.form.userWeight = null
        this.form.userHeightMeters = null
        this.setInputsWeightHeight()
        this.form.userEmail = ''
        this.form.userPhone = ''
        this.form.userRace = ''
        this.form.userOccupation = ''
        this.form.emergencyFname = null
        this.form.emergencyLname = null
        this.form.emergencyAddress = null
        this.form.emergencyCity = null
        this.form.emergencyState = null
        this.form.emergencyZip = null
        this.form.emergencyPhn = null
        this.form.primaryFname = null
        this.form.primaryLname = null
        this.form.primarySpeciality = null
        this.form.primaryHospital = null
        this.form.primaryPhn = null
        this.form.notes = ''
      }
    },

    async updateCaringUser() {
      try {
        const responseData = await caringCircleService.updateCaringCircleUsers({
          dependent: {
            dependent_id: this.userData.emergency_contact_data.dependent_id,
            patient_id: this.userData.dependent_data.patient_id,
            first_name: this.form.userFname,
            last_name: this.form.userLname,
            date_of_birth: this.date,
            relationship: {
              key: this.form.userRelation,
              value: this.relationships.find(
                (x) => x.key === this.form.userRelation
              ).value,
            },
            sex: {
              key: this.form.userSex,
              value: this.sex.find((x) => x.key === this.form.userSex).value,
            },
            gender: this.form.userGenderIdentity
              ? {
                  key: this.form.userGenderIdentity,
                  value: this.genderIdentity.find(
                    (x) => x.key === this.form.userGenderIdentity
                  ).value,
                }
              : null,
            weight: this.imperialUnits
              ? this.lbsTOkg(this.form.userWeightLbs)
              : this.form.userWeight,
            height: this.imperialUnits
              ? this.meterConversion(this.form.userHeightFt)
              : this.form.userHeightMeters,
            race: this.form.userRace
              ? {
                  key: this.form.userRace,
                  value: this.ethnicity.find(
                    (x) => x.key === this.form.userRace
                  ).value,
                }
              : null,
            occupation: this.form.userOccupation,
            notes: this.form.notes,
            email: this.form.userEmail,
            phone_number: this.form.userPhone,
          },
          emergency_contact: {
            emergency_contact_id: null,
            dependent_id: null,
            first_name: null,
            last_name: null,
            address: null,
            city: null,
            state: null,
            zipcode: null,
            phone_number: null,
          },
          physician: {
            dependent_physician_id: null,
            dependent_id: null,
            first_name: null,
            last_name: null,
            speciality: null,
            hospital: null,
            phone_number: null,
          },
        })
        if (responseData && responseData.data) {
          this.userMessage = 'User information updated successfully!'
          this.snackbarMessage = 'Saved Successfully'
          this.snackbar = true
        }
      } catch (error) {
        console.warn(error)
        if (error.response.data) {
          const str = error.response.data
          this.invalidMessage = str.substring(
            str.indexOf("string='") + 8,
            str.indexOf("code='") - 4
          )
        }
      }
    },
    async saveCaringUserData() {
      try {
        const responseData = await caringCircleService.saveCaringCircleUsers({
          dependent: {
            first_name: this.form.userFname,
            last_name: this.form.userLname,
            date_of_birth: this.date,
            relationship: {
              key: this.form.userRelation,
              value: this.relationships.find(
                (x) => x.key === this.form.userRelation
              ).value,
            },
            sex: {
              key: this.form.userSex,
              value: this.sex.find((x) => x.key === this.form.userSex).value,
            },
            gender: this.form.userGenderIdentity
              ? {
                  key: this.form.userGenderIdentity,
                  value: this.genderIdentity.find(
                    (x) => x.key === this.form.userGenderIdentity
                  ).value,
                }
              : null,
            weight: this.imperialUnits
              ? this.lbsTOkg(this.form.userWeightLbs)
              : this.form.userWeight,
            height: this.imperialUnits
              ? this.meterConversion(this.form.userHeightFt)
              : this.form.userHeightMeters,
            race: this.form.userRace
              ? {
                  key: this.form.userRace,
                  value: this.ethnicity.find(
                    (x) => x.key === this.form.userRace
                  ).value,
                }
              : null,
            occupation: this.form.userOccupation,
            notes: this.form.notes,
            email: this.form.userEmail,
            phone_number: this.form.userPhone,
          },
          emergency_contact: {
            first_name: null,
            last_name: null,
            address: null,
            city: null,
            state: null,
            zipcode: null,
            phone_number: null,
          },
          physician: {
            first_name: null,
            last_name: null,
            speciality: null,
            hospital: null,
            phone_number: null,
          },
        })
        if (responseData && responseData.data) {
          this.userMessage = 'User information added successfully!'
          this.snackbarMessage = 'Saved Successfully'
          this.snackbar = true
        }
      } catch (error) {
        console.warn(error)
        if (error.response.data) {
          const str = error.response.data
          this.invalidMessage = str.substring(
            str.indexOf("string='") + 8,
            str.indexOf("code='") - 4
          )
        }
      }
    },

    setInputsWeightHeight() {
      this.form.userWeightLbs =
        this.form.userWeight !== null
          ? parseFloat(this.form.userWeight * 2.20462).toFixed(1)
          : null

      this.form.userHeightFt =
        this.form.userHeightMeters !== null
          ? parseInt(this.form.userHeightMeters / 0.3048)
          : null
      this.form.userHeightIn =
        this.form.userHeightMeters !== null
          ? Math.round((this.form.userHeightMeters % 0.3048) / 0.0254)
          : null
    },

    lbsTOkg(data) {
      if (data) return parseFloat(this.form.userWeightLbs / 2.20462).toFixed(3)
      else return null
    },
    meterConversion(data) {
      if (data)
        return parseFloat(
          this.form.userHeightFt * 0.3048 + this.form.userHeightIn * 0.0254
        ).toFixed(2)
      else return null
    },

    validate() {
      this.$refs.form.validate()
      if (!this.userData) {
        this.saveCaringUserData()
      } else this.updateCaringUser()
    },

    onChangeInput() {
      this.changeData = true
      this.successMessage = null
      this.invalidMessage = null
    },

    isLetter(e) {
      const char = String.fromCharCode(e.keyCode)
      if (/^[A-Za-z, ]+$/.test(char)) return true
      else e.preventDefault()
    },

    isNotLetter(e) {
      const char = String.fromCharCode(e.keyCode)
      if (!/^[A-Za-z]+$/.test(char)) return true
      else e.preventDefault()
    },

    goBack() {
      this.$router.back()
    },

    resetForm() {
      this.updateCaringUserInfo()
    },
  },
}
</script>

<template>
  <v-container :class="$style.pageContainer">
    <v-row class="mt-2 justify-center">
      <v-col cols="12" md="1" sm="1" lg="1" xl="1" class="pt-0">
        <div :class="$style.backClass">
          <a
            :class="[$style.clickable, 'pl-10 pl-sm-0']"
            class="primary--text"
            @click="goBack"
          >
            <v-icon size="large" color="primary"> mdi-chevron-left </v-icon>
            Back
          </a>
        </div>
      </v-col>
      <v-col cols="11" md="6" sm="6" lg="6" xl="6" :class="$style.inputPan">
        <div :class="$style.pageText">
          <p :class="$style.pageDesc">
            Enter information for person in your caring circle.
          </p>
        </div>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          :class="$style.form"
          @submit.prevent="validate"
        >
          <v-row>
            <v-col cols="12" md="12" class="pb-0 mt-2">
              <label>First Name<span :class="$style.mandatory">*</span> </label>
              <v-text-field
                v-model="form.userFname"
                :maxlength="30"
                outlined
                required
                :rules="fnameRule"
                @keypress="isLetter($event)"
                @keydown="onChangeInput"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" class="py-0">
              <label>Last Name<span :class="$style.mandatory">*</span> </label>
              <v-text-field
                v-model="form.userLname"
                :maxlength="30"
                outlined
                required
                :rules="lnameRule"
                @keypress="isLetter($event)"
                @keydown="onChangeInput"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" class="py-0">
              <label :class="$style.textLabel"
                >Date of Birth<span :class="$style.mandatory">*</span></label
              >
              <v-menu
                v-model="selectDate"
                :close-on-content-click="false"
                max-width="290"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    slot="activator"
                    :value="computedDateFormatted"
                    :append-icon="iconCalender"
                    :rules="[(v) => !!v || 'Required Field']"
                    outlined
                    readonly
                    v-on="on"
                    @click:append="on.click"
                    @focus="onChangeInput"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  :max="new Date().toISOString().substr(0, 10)"
                  @change=";(selectDate = false), onChangeInput"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" md="6" class="py-0">
              <label
                >Relationship to me<span :class="$style.mandatory">*</span>
              </label>
              <v-select
                v-model="form.userRelation"
                hide-details="auto"
                outlined
                :items="relationships"
                item-text="value"
                item-value="key"
                :rules="requiredRule"
                @change="onChangeInput"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <label :class="$style.textLabel"
                >Sex<span :class="$style.mandatory">*</span></label
              >
              <v-select
                v-model="form.userSex"
                hide-details="auto"
                outlined
                :items="sex"
                item-text="value"
                item-value="key"
                :rules="requiredRule"
                @change="onChangeInput"
              ></v-select>
            </v-col>

            <v-col cols="12" md="6">
              <label :class="$style.textLabel">Gender Identity</label>
              <v-select
                v-model="form.userGenderIdentity"
                hide-details="auto"
                outlined
                :items="genderIdentity"
                item-text="value"
                item-value="key"
                @change="onChangeInput"
              ></v-select>
            </v-col>
          </v-row>
          <v-row v-if="imperialUnits">
            <v-col cols="12" md="6" class="py-0 mt-4">
              <label :class="$style.textLabel">Weight</label>
              <v-text-field
                v-model="form.userWeightLbs"
                :rules="notGreekRule"
                outlined
                suffix="lbs"
                hint="less than 650"
                :maxlength="7"
                @paste.prevent
                @keydown="onChangeInput"
                @keypress="onlyLBS($event, form.userWeightLbs, 6)"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" class="py-0 mt-4">
              <label :class="$style.textLabel">Height</label>
              <v-text-field
                v-model="form.userHeightFt"
                :rules="notGreekRule"
                :maxlength="2"
                outlined
                required
                hint="7 ft 10 inches"
                suffix="ft"
                @paste.prevent
                @keypress="onlyHeightFeet($event, form.userHeightFt)"
                @keydown="onChangeInput"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" class="py-0 mt-4">
              <label :class="$style.textLabel">&nbsp;</label>
              <v-text-field
                v-model="form.userHeightIn"
                :rules="notGreekRule"
                outlined
                required
                suffix="In"
                :maxlength="2"
                @paste.prevent
                @keypress="onlyInches($event, form.userHeightIn)"
                @keydown="onChangeInput"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="!imperialUnits">
            <v-col cols="12" md="4" class="py-0 mt-4">
              <label :class="$style.textLabel">Weight</label>
              <v-text-field
                v-model="form.userWeight"
                :rules="notGreekRule"
                outlined
                suffix="kgs"
                hint="less than 300"
                :maxlength="6"
                @paste.prevent
                @keypress="onlyKG($event, form.userWeight, 5)"
                @keydown="onChangeInput"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" class="py-0 mt-4">
              <label :class="$style.textLabel">Height</label>
              <v-text-field
                v-model="form.userHeightMeters"
                outlined
                hint="less than 2.4"
                :rules="notGreekRule"
                :maxlength="4"
                suffix="m"
                @paste.prevent
                @keypress="onlyHeightMeter($event, form.userHeightMeters, 3)"
                @keydown="onChangeInput"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12" md="12">
              <label :class="$style.textLabel">Email</label>
              <v-text-field
                v-model="form.userEmail"
                :rules="emailRules"
                append-icon="mdi-email-outline"
                outlined
                required
                @keydown="onChangeInput"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12" md="12">
              <label :class="$style.textLabel">Race/Ethnicity</label>
              <v-select
                v-model="form.userRace"
                hide-details="auto"
                outlined
                :items="ethnicity"
                item-text="value"
                item-value="key"
                @change="onChangeInput"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12" md="12">
              <label :class="$style.textLabel">Occupation</label>
              <v-text-field
                v-model="form.userOccupation"
                :rules="notGreekRule"
                :maxlength="30"
                outlined
                required
                @keypress="isLetter($event)"
                @keydown="onChangeInput"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12" md="12" class="py-0 mb-4">
              <label :class="$style.textLabel">Phone Number</label>
              <VueTelInputVuetify
                v-model="form.userPhone"
                outlined
                label=""
                :max-len="15"
                placeholder="555-555-5555"
                :only-countries="['US']"
                default-country="US"
                mode="international"
                @keydown="onChangeInput, isNotLetter($event)"
              >
              </VueTelInputVuetify>
            </v-col>
          </v-row>
          <v-divider width="670" />

          <!-- Notes -->
          <v-row>
            <v-col cols="12" md="12" class="mt-4">
              <label :class="$style.textLabel">Notes</label>
              <v-textarea
                v-model="form.notes"
                :rules="notGreekRule"
                :maxlength="200"
                outlined
                name="input-7-4"
                @keydown="onChangeInput"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row class="row mt-6 mb-8">
            <v-col>
              <v-btn
                rounded
                width="280"
                :class="[$style.saveButtonClass, 'primary-btn']"
                :disabled="disableButton"
                @click="validate"
              >
                Save
              </v-btn>

              <v-btn
                text
                color="Black"
                :class="$style.cancelText"
                @click="resetForm"
                >Cancel</v-btn
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="invalidMessage">
              <p :class="$style.errorMessage" class="red--text" role="alert">
                {{ invalidMessage }}
              </p>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
      <v-col cols="12" md="5" sm="5" lg="5" xl="5" class="pt-0">
        <CaringProfilePicture
          :first-name="form.userFname"
          :last-name="form.userLname"
          :url="form.profilePictureUrl"
          :dependentid="
            userData ? userData.emergency_contact_data.dependent_id : null
          "
        ></CaringProfilePicture>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <CustomSnackbar
          :snackbar="snackbar"
          :snackbar-message="snackbarMessage"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.pageContainer {
  max-width: 100%;
}
.imgclss {
  margin-top: 6px !important;
}

.profilePicClass {
  margin-left: -15%;
}

.clickable {
  display: inline-flex;
  margin-bottom: 2px;
  font-size: 14px;
  vertical-align: middle;
}

.mandatory {
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  color: #da1414;
}

.form label {
  display: inline-block;
  margin-bottom: 10px;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  color: #454648;
  letter-spacing: 0.2px;
}
.inputPan {
  border: 1px solid #93c0e8;
  border-radius: 4px;
}
.pageText {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
  letter-spacing: 0.1px;
}

.pageDesc {
  margin: 0 !important;
  font-size: 14px;
  line-height: 24px;
  text-align: left;
}

.textLabel {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: #454648;
  letter-spacing: 0.2px;
}

.emergencytext {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.87);
  letter-spacing: 0.1px;
}

.saveButtonClass {
  margin-right: 8px;
  text-transform: inherit !important;
}

.cancelText {
  width: 120px;
  text-transform: none;
}

.successMessage {
  font-size: 14px;
  font-weight: bold;
}

.errorMessage {
  font-size: 14px;
  font-weight: bold;
  color: #da1414;
}
@media screen and (max-width: 959px) {
  .pageDesc {
    text-align: left;
  }
  .backClass {
    margin-left: -5%;
  }
  .form label {
    font-size: 11px;
  }
}
@media screen and (max-width: 768px) {
  .saveButtonClass,
  .cancelText {
    width: 100% !important;
    margin-bottom: 15px;
    margin-left: 1px;
  }
}
</style>

<style scoped>
/deep/ .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  color: #fff !important;
  background-color: #b5bfdb !important;
}

/deep/ .v-text-field--outlined > .v-input__control > .v-input__slot {
  background: #fff;
}

/deep/ .v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0;
}
/deep/ .v-select__selection--comma {
  font-size: 14px;
}
/deep/ .theme--light.v-select .v-select__selections {
  font-size: 14px;
}
</style>
